import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import { createDisplayConfig } from '../constants';
import { useMapCore } from '../hooks/useMapCore';
import { useMapLayers } from '../hooks/useMapLayers';
import { useMapToolbar } from '../hooks/useMapToolbar';
import { useLegend } from '../hooks/useLegend';
import { MapToolbar } from './map-toolbar';
import { MapAttribution } from './map-attribution';
import { LegendPanel } from './legend-panel';
export const ArcGISMap = (props) => {
    var _a;
    const { config = createDisplayConfig(), layerData: { areas = [], items = [] } = {}, className, onItemClick, renderPopup, selectedItem: externalSelectedItem, tileLayers = [], onMapReady, clustering, kindFilter, mapItem, mapItemToMarker, mapItemToAttributes, } = props;
    const graphicsLayerRef = useRef(null);
    const { isLegendOpen, toggleLegend, closeLegend, hiddenKinds, uniqueKinds, toggleKind, showUnclaimed, toggleUnclaimed } = useLegend(kindFilter);
    const mapCore = useMapCore({
        config,
        tileLayers,
        areas,
        graphicsLayerRef,
    });
    useEffect(() => {
        if (mapCore.mapReady && mapCore.mapView && onMapReady)
            onMapReady(mapCore.mapView);
    }, [mapCore.mapReady, mapCore.mapView, onMapReady]);
    const mapLayers = useMapLayers({
        mapView: mapCore.mapView,
        mapReady: mapCore.mapReady,
        areas,
        items,
        symbols: config.symbols,
        onItemClick,
        configZoom: config.zoom,
        hiddenKinds,
        showUnclaimed,
        clustering,
        mapItem,
        mapItemToMarker,
        mapItemToAttributes,
    });
    // Sync externally-selected property into the map's popup state
    useEffect(() => {
        if (externalSelectedItem)
            mapLayers.setSelectedItem(externalSelectedItem);
    }, [externalSelectedItem, mapLayers.setSelectedItem]);
    return (_jsxs("div", { style: {
            position: 'relative',
            height: config.height || '100%',
            width: config.width || '100%',
        }, className: className, children: [_jsx(MapToolbar, { toolbar: useMapToolbar({
                    basemap: mapCore.basemap,
                    setBasemap: mapCore.setBasemap,
                    tileLayerVisibility: mapCore.tileLayerVisibility,
                    setTileLayerVisibility: mapCore.setTileLayerVisibility,
                    handleZoomIn: mapCore.handleZoomIn,
                    handleZoomOut: mapCore.handleZoomOut,
                    handleRecenter: mapCore.handleRecenter,
                    tileLayers,
                    showBasemapSelector: config.showBasemapSelector,
                }), additionalTools: config.showLegend !== false && uniqueKinds.length > 0 ? (_jsxs("button", { className: `btn btn-sm shadow-sm ${isLegendOpen ? 'btn-primary' : 'btn-light'}`, onClick: toggleLegend, title: "Toggle Legend", children: [_jsx("i", { className: "bi bi-map me-1" }), "Legend"] })) : null }), config.showLegend !== false && isLegendOpen && (_jsx(LegendPanel, { kinds: uniqueKinds, hiddenKinds: hiddenKinds, onToggleKind: toggleKind, showUnclaimed: showUnclaimed, onToggleUnclaimed: toggleUnclaimed, onClose: closeLegend })), _jsx("div", { ref: mapCore.mapDiv, className: 'w-100 h-100', style: { touchAction: 'none' } }), _jsx(MapAttribution, { mapView: mapCore.mapView }), mapLayers.selectedItem && renderPopup(mapLayers.selectedItem, () => mapLayers.setSelectedItem(null), (_a = mapCore.mapDiv.current) === null || _a === void 0 ? void 0 : _a.clientWidth)] }));
};
/* LEGACY/HELPER */
import { konstPromise } from '@rad/utility/promise';
import { PropertyPopup } from '../components/parcel-popup';
import { mapPropertyToMapAttributes } from '../../../../../types';
export const ArcGISMapLegacyHelper = (props) => _jsx(ArcGISMap, Object.assign({}, props, { mapItem: (x) => {
        var _a;
        return (Object.assign(Object.assign({}, x), { 'kind': x.parcel.kind && Object.assign(Object.assign({}, x.parcel.kind), { 'id': (_a = x.parcel.kind) === null || _a === void 0 ? void 0 : _a.name }), 'point': x.parcel.point }));
    }, mapItemToMarker: (x) => x.parcel.kind && Object.assign(Object.assign({}, x.parcel.kind), { 'id': x.parcel.kind.name }), mapItemToAttributes: mapPropertyToMapAttributes, renderPopup: (x, onClose, containerWidth) => _jsx(PropertyPopup, { position: x, property: konstPromise(x), onClose: onClose, containerWidth: containerWidth }) }));
